import React from 'react';
import { ListItemIcon, ListItemText, ListItemButton, styled } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface StyledListItemButtonProps {
  nested: number;
}

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 30,
  color: 'inherit',
  alignItems: 'center',
  '& > svg': {
    fontSize: 20,
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& > span': {
    color: 'inherit',
    fontSize: 13,
    fontWeight: 600,
  },
}));

const StyledListItemButton = styled(ListItemButton)<StyledListItemButtonProps>(({ theme, nested }) => ({
  padding: theme.spacing(0.875, 1.25),
  paddingLeft: nested ? theme.spacing(nested) : theme.spacing(1.25),
  minHeight: 42,
  gap: theme.spacing(1),
  marginBottom: 2,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.primary.main,
  },
}));

interface SidebarItemMoreProps {
  text: string;
  icon?: React.ReactElement;
  nested?: number;
  handleClick(): void;
}

const SidebarItemMore: React.FC<SidebarItemMoreProps> = ({ icon, text, handleClick, nested = 0 }) => {
  return (
    <StyledListItemButton nested={nested} onClick={handleClick}>
      {icon && <StyledListItemIcon>{icon}</StyledListItemIcon>}
      <StyledListItemText color="inherit" primary={text} />
      <ChevronRightIcon color="inherit" />
    </StyledListItemButton>
  );
};

export default SidebarItemMore;
